export const RESPONSE_DISMISS_MSG = 'Are you sure you want to delete this response?';
export const DELETE_RESPONSE_TITLE = 'Delete Response';
export const ERROR_DOWNLOADING_DOCUMENT_TITLE = 'Error Downloading Generated Document';
export const UPLOADED_FILES_NOT_AVAILABLE_FOR_DOWNLOAD = 'Files updated in version 1.3 and lower are not available to download.';
export const DOWNLOAD_FILE = 'Download File';
